import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {HomePageRoutingModule} from './home-routing.module';

import {HomePage} from './home.page';
import {PartialsModule} from '../../partials/partials.module';
import {TranslateModule} from '@ngx-translate/core';
import { PipesModule } from '../../pipes/pipes.module';
import {QRCodeModule} from 'angularx-qrcode';
import {NgxJsonViewerModule} from '../../partials/ngx-json-viewer/ngx-json-viewer.module';
import {VirtualKeyboardDirective} from '../../shared/virtual-keyboard/virtual-keyboard.directive';
import {VirtualKeyboardComponent} from '../../shared/virtual-keyboard/virtual-keyboard.component';
import {AnimatedNumberComponent} from './animated-number.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomePageRoutingModule,
    PartialsModule,
    TranslateModule,
    PipesModule,
    QRCodeModule,
    NgxJsonViewerModule,
  ],
  declarations: [HomePage, VirtualKeyboardDirective, VirtualKeyboardComponent, AnimatedNumberComponent],
  exports: [HomePage]
})
export class HomePageModule {
}
